/* eslint-disable quotes */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChatBoardHeader from "./chatboard/chatboardHeader";
import ChatBoardBody from "./chatboard/chatboardBody";
import ChatBoardFooter from "./chatboard/chatboardFooter";
import ChatBoardWelcome from "./chatboard/ChatboardWelcome";
import { getAuthSession, getObjectLength } from "./Helpers/common";
import {
  _getUpdatedChatMessage,
  _getUpdatedChatSupportMessage,
} from "../SocketIo";
import { setWelcomeBoard } from "./redux/authUserDetail";
import { setActiveThreadChat, setAttendeeData } from "./redux/chatSlice";
import ThreadboardBody from "./threadboard/threadboardBody";
import ThreadboardHeader from "./threadboard/threadboardHeader";
import { useSearchParams } from "react-router-dom";
import { clearUnreadThreadCount, openUserChat } from "./Helpers/chatCommon";
import ThreadboardFooter from "./threadboard/threadboardFooter";
import ProgressBar from "./chatboard/progressBar";
import SupportBoard from "./phoneSupport";

const ChatBoard = () => {
  const dispatch = useDispatch();
  const [chatWidth, setChatWidth] = useState(60);
  const [isResizing, setIsResizing] = useState(false);
  const { user_unique_key: senderID } = getAuthSession();

  const { welcomeBoard } = useSelector((state) => state?.authUserDetail || {});

  const {
    attendeeData,
    groupList,
    selectedLanguage,
    chatboardSelectedTab,
    activeThreadChat,
    chatRoom,
    attendeeList,
    progressThread = 0,
    showPhoneSupport: isPhoneSupport,
  } = useSelector((state) => state?.chat || {});

  const { allAttendeeList } = useSelector((state) => state?.call || {});

  const UserData = attendeeData || {};

  const [searchParams, setSearchParams] = useSearchParams();
  const chatRoomParam = searchParams.get("chatroom");
  const isGroupNotification = searchParams.get("type") === "group";
  const parentMsgId = searchParams.get("parent_id");

  const isInThread = Object.keys(activeThreadChat).includes(chatRoom);

  React.useEffect(() => {
    if (isPhoneSupport) return;
    if (getObjectLength(attendeeData)) {
      if (attendeeData?.type == "group") {
        const selectedData = groupList.find(
          (item) => item?.groupId === attendeeData?.groupId,
        );
        if (selectedData === undefined) {
          dispatch(setAttendeeData({}));
        } else {
          const userNameData = [];
          selectedData?.attendeeId?.forEach((item) => {
            const filterUsername = allAttendeeList?.filter(
              (v) => v?.user_id === item,
            );
            if (filterUsername && filterUsername.length > 0) {
              userNameData.push(filterUsername[0].name);
            }
          });
          const username =
            userNameData?.length > 0 ? userNameData.toString() : "";
          dispatch(
            setAttendeeData({ ...selectedData, type: "group", username }),
          );
        }
      } else {
        const selectedData = allAttendeeList.find(
          (item) => item.user_id === attendeeData?.user_id,
        );
        dispatch(
          setAttendeeData(
            selectedData === undefined
              ? {}
              : {
                  ...selectedData,
                  role_name: selectedData.role,
                  type: "attendee",
                },
          ),
        );
      }
    }
  }, [allAttendeeList, groupList]);

  useEffect(() => {
    if (isPhoneSupport) {
      dispatch(setWelcomeBoard(true));
      return;
    }

    if (getObjectLength(attendeeData)) {
      if (attendeeData?.type == "attendee") {
        dispatch(setWelcomeBoard(true));
      } else {
        if (
          attendeeData?.attendeeId?.includes(senderID) &&
          attendeeData?.type == "group"
        ) {
          dispatch(setWelcomeBoard(true));
        } else {
          dispatch(setWelcomeBoard(false));
        }
      }
    } else {
      dispatch(setWelcomeBoard(false));
    }
  }, [attendeeData, isPhoneSupport]);

  useEffect(() => {
    _getUpdatedChatMessage(senderID);
    _getUpdatedChatSupportMessage(senderID);
  }, []);

  useEffect(() => {
    if (chatRoomParam) {
      //For Private Msg Notification
      if (attendeeList && !isGroupNotification) {
        console.log("For Private Msg Notification");
        const paramAttendeeData = attendeeList?.find((v) =>
          chatRoomParam?.split("_")?.includes(v?.user_id),
        );
        openUserChat(paramAttendeeData, isGroupNotification);
      }
      //For Group Msg Notification
      if (groupList?.length > 0 && isGroupNotification) {
        console.log("For Group Msg Notification");

        const paramGroupData = groupList?.find(
          (v) => v?.groupId === chatRoomParam,
        );
        openUserChat(paramGroupData, isGroupNotification);
      }

      //For thread Notification
      if (parentMsgId && parentMsgId != "undefined" && parentMsgId != "null") {
        dispatch(
          setActiveThreadChat({
            documentID: chatRoomParam,
            id: parentMsgId,
          }),
        );
      }

      setSearchParams({});
      clearUnreadThreadCount(chatRoomParam, parentMsgId, UserData?.company_id);
    }
  }, [chatRoomParam, attendeeList, parentMsgId, groupList]);

  const startResize = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsResizing(true);
    document.body.style.cursor = "col-resize";

    const startX = e.clientX;
    const startWidth = chatWidth;

    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startX;
      const screenWidth = window.innerWidth;

      let newWidth = startWidth + (delta / screenWidth) * 100;
      newWidth = Math.max(33, Math.min(67, newWidth));

      setChatWidth(newWidth);
    };

    const onMouseUp = () => {
      setIsResizing(false);
      document.body.style.cursor = "default";
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <>
      {welcomeBoard ? (
        <div className={`right_s ${isInThread ? "d-flex w-full" : ""}`}>
          <div
            className="chat_box"
            style={{ width: isInThread ? `${chatWidth}%` : "100%" }}
          >
            {isPhoneSupport ? (
              <SupportBoard {...{ chatboardSelectedTab }} />
            ) : (
              <>
                <ChatBoardHeader />
                <div
                  className={`body body-inner ${
                    chatboardSelectedTab === "thread" && " flex-column"
                  }`}
                >
                  {getObjectLength(UserData) && <ChatBoardBody />}
                </div>

                {chatboardSelectedTab === "messages" && (
                  <ChatBoardFooter isPhoneSupport={isPhoneSupport} />
                )}
              </>
            )}
          </div>

          {isInThread && (
            <>
              <div
                className="resize-handle"
                onMouseDown={startResize}
                style={{
                  backgroundColor: isResizing && "#1e90ff",
                  width: isResizing && "3px",
                }}
              />
              <div
                className="thread_box border-left border-light h-100 d-flex flex-column position-relative"
                style={{ width: `${100 - chatWidth}%` }}
              >
                <ThreadboardHeader />

                {progressThread !== "" && (
                  <ProgressBar progress={progressThread} />
                )}

                <div className="body body-inner">
                  {getObjectLength(UserData) && <ThreadboardBody />}
                </div>
                <ThreadboardFooter isInThread={isInThread} />
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="right_s">
          <div className="chat_box">
            <div className="body">
              <ChatBoardWelcome selectedLanguage={selectedLanguage} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBoard;
